import { render } from "./Refund.vue?vue&type=template&id=7241e0d7"
import script from "./Refund.vue?vue&type=script&lang=js"
export * from "./Refund.vue?vue&type=script&lang=js"
script.render = render

export default script